// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #c9ccd3;
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%);
  background-blend-mode: lighten;
  position: relative;
}
.login-page .ractangle {
  position: absolute;
  height: 30px;
  width: 30px;
  rotate: 45deg;
  top: 30px;
  left: 30px;
  animation: mymove3 1s infinite;
  background-color: #fff;
  background-image: linear-gradient(to right, #ec77ab 0%, #7873f5 100%);
  box-shadow: 26px 26px 72px #c7c7c7, -26px -26px 84px #f9f9f9;
}
.login-page .ractangle-two {
  position: absolute;
  height: 30px;
  width: 30px;
  rotate: 45deg;
  right: 30px;
  bottom: 30px;
  animation: mymove3 1s infinite;
  background-color: #fff;
  background-image: linear-gradient(to right, #ec77ab 0%, #7873f5 100%);
  box-shadow: 26px 26px 72px #c7c7c7, -26px -26px 84px #f9f9f9;
}
.login-page .login-form {
  border: 1px solid #fff;
  box-shadow: 26px 26px 72px #c7c7c7, -26px -26px 84px #f9f9f9;
  padding: 70px 40px;
  width: 430px;
  min-height: 600px;
  background-color: #fff;
  text-align: center;
  border-radius: 20px;
  z-index: 99;
}
.login-page .login-form .forget-pass {
  font-size: 15px;
  font-weight: 700;
  color: #c850c0;
  display: block;
  padding-top: 25px;
}
.login-page .login-form .forget-pass:hover {
  text-decoration: none;
}
.login-page .login-form .account-not {
  padding: 15px 0px;
  font-size: 14px;
  font-weight: 700;
}
.login-page .login-form .account-not .going-link {
  color: #4158d0;
  margin-left: 2px;
}
.login-page .login-form .account-not .going-link:hover {
  text-decoration: none;
}
.login-page .main-heading {
  background-color: -webkit-linear-gradient(105deg, #4158d0 41%, #c850c0 46%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@keyframes mymove {
  0% {
    width: 300px;
    height: 300px;
  }
  50% {
    width: 120px;
    height: 120px;
  }
  100% {
    width: 300px;
    height: 300px;
  }
}
@keyframes mymove2 {
  0% {
    width: 200px;
    height: 200px;
  }
  50% {
    width: 100px;
    height: 100px;
  }
  100% {
    width: 200px;
    height: 200px;
  }
}
@keyframes mymove3 {
  0% {
    width: 30px;
    height: 30px;
  }
  50% {
    width: 31px;
    height: 31px;
  }
  100% {
    width: 30px;
    height: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Login/LoginPage.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gGAAA;EAKA,8BAAA;EACA,kBAAA;AAHF;AAKE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;EACA,sBAAA;EACA,qEAAA;EACA,4DAAA;AAHJ;AAME;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,qEAAA;EACA,4DAAA;AAJJ;AAOE;EACE,sBAAA;EACA,4DAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AALJ;AAMI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AAJN;AAKM;EACE,qBAAA;AAHR;AAMI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAKM;EACE,cAAA;EACA,gBAAA;AAHR;AAIQ;EACE,qBAAA;AAFV;AAOE;EACE,2EAAA;EACA,6BAAA;EACA,oCAAA;AALJ;;AASA;EACE;IACE,YAAA;IACA,aAAA;EANF;EAQA;IACE,YAAA;IACA,aAAA;EANF;EAQA;IACE,YAAA;IACA,aAAA;EANF;AACF;AASA;EACE;IACE,YAAA;IACA,aAAA;EAPF;EASA;IACE,YAAA;IACA,aAAA;EAPF;EASA;IACE,YAAA;IACA,aAAA;EAPF;AACF;AAUA;EACE;IACE,WAAA;IACA,YAAA;EARF;EAUA;IACE,WAAA;IACA,YAAA;EARF;EAUA;IACE,WAAA;IACA,YAAA;EARF;AACF","sourcesContent":[".login-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #c9ccd3;\n  background-image: linear-gradient(\n    -180deg,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  background-blend-mode: lighten;\n  position: relative;\n\n  .ractangle {\n    position: absolute;\n    height: 30px;\n    width: 30px;\n    rotate: 45deg;\n    top: 30px;\n    left: 30px;\n    animation: mymove3 1s infinite;\n    background-color: #fff;\n    background-image: linear-gradient(to right, #ec77ab 0%, #7873f5 100%);\n    box-shadow: 26px 26px 72px #c7c7c7, -26px -26px 84px #f9f9f9;\n  }\n\n  .ractangle-two {\n    position: absolute;\n    height: 30px;\n    width: 30px;\n    rotate: 45deg;\n    right: 30px;\n    bottom: 30px;\n    animation: mymove3 1s infinite;\n    background-color: #fff;\n    background-image: linear-gradient(to right, #ec77ab 0%, #7873f5 100%);\n    box-shadow: 26px 26px 72px #c7c7c7, -26px -26px 84px #f9f9f9;\n  }\n\n  .login-form {\n    border: 1px solid #fff;\n    box-shadow: 26px 26px 72px #c7c7c7, -26px -26px 84px #f9f9f9;\n    padding: 70px 40px;\n    width: 430px;\n    min-height: 600px;\n    background-color: #fff;\n    text-align: center;\n    border-radius: 20px;\n    z-index: 99;\n    .forget-pass {\n      font-size: 15px;\n      font-weight: 700;\n      color: #c850c0;\n      display: block;\n      padding-top: 25px;\n      &:hover {\n        text-decoration: none;\n      }\n    }\n    .account-not {\n      padding: 15px 0px;\n      font-size: 14px;\n      font-weight: 700;\n      .going-link {\n        color: #4158d0;\n        margin-left: 2px;\n        &:hover {\n          text-decoration: none;\n        }\n      }\n    }\n  }\n  .main-heading {\n    background-color: -webkit-linear-gradient(105deg, #4158d0 41%, #c850c0 46%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n}\n\n@keyframes mymove {\n  0% {\n    width: 300px;\n    height: 300px;\n  }\n  50% {\n    width: 120px;\n    height: 120px;\n  }\n  100% {\n    width: 300px;\n    height: 300px;\n  }\n}\n\n@keyframes mymove2 {\n  0% {\n    width: 200px;\n    height: 200px;\n  }\n  50% {\n    width: 100px;\n    height: 100px;\n  }\n  100% {\n    width: 200px;\n    height: 200px;\n  }\n}\n\n@keyframes mymove3 {\n  0% {\n    width: 30px;\n    height: 30px;\n  }\n  50% {\n    width: 31px;\n    height: 31px;\n  }\n  100% {\n    width: 30px;\n    height: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
